import React from 'react';
import Viewer from 'viewerjs';

import 'viewerjs/dist/viewer.css';
import { toJS } from 'mobx';
class MdEditor extends React.Component {
  componentDidMount() {
    this.init();
  }
  createViewer() {
    // console.log('createViewer');
    if(this.imageInstance) {
      // console.log('createViewer  123 destroy');
      this.imageInstance.images = [];
      this.imageInstance.items = [];
      this.imageInstance.destroy();
      this.imageInstance = null;
      window.jQuery('.viewer-container').remove();
    }
    // console.log(document.getElementById('md-editor'));
    if(document.getElementById('md-editor')!==null) {
      const viewer = new Viewer(document.getElementById('md-editor'), {
        inline: false,
        viewed() {

        },
        url(img) {
          // if (img.src.includes('cloudstore/release') && !img.src.endsWith('-big.png')) {
          //   return img.src;
          //   //return img.src.replace('.png', '-big.png'); //这个逻辑后端漏了
          // }
          // else {
          return img.src;
          // }
        }
      });
      this.imageInstance = viewer;
    }
    // console.log(this.imageInstance);
  }
  init() {
    if(this.instance) {
      const {appId} = this.props;
      this.instance.settings.appId = appId;
      this.createViewer();
      return ;
    }
    let _this = this;
    const {code,ecodeStore, ecodeStore: { readme, id, access_token },appId} = this.props;
    ecodeStore.setLoading(true);
    window.editormd("md-editor", {
      width  : "100%",
      height : 800,
      appId: appId,
      path   : "https://e-cloudstore.com/doc/editormd/lib/",
      markdown: readme||'',
      tex:true,
      tocm:true,
      flowChart:true,
      taskList:true,
      sequenceDiagram:true,
      htmlDecode : true,
      emoji:false,
      autoFocus: false,
      imageUpload    : true,
      imageFormats   : ["jpg", "jpeg", "gif", "png", "bmp", "webp"],
      imageUploadURL : window.server + "/v5/ecode/uploadImg?&id="+ id + "&cs_token="+ access_token + '&type=usefile' + '&',
      toolbarIcons : function() {
        return [
          "undo", "redo", "|",
          "bold", "del", "italic", "quote", "ucwords", "uppercase", "lowercase", "|",
          "h1", "h2", "h3", "h4", "h5", "h6", "|",
          "list-ul", "list-ol", "hr", "|",
          "link", "reference-link", "image", "code", "preformatted-text", "code-block", "table", "datetime", "html-entities", "pagebreak", "|",
          "goto-line", "watch", "preview", "fullscreen", "clear", "search", "|",
          "help"
        ];
        //, "emoji"
      },
      onchange : function() {
        // console.log("onchange =>", this);
        if(_this.props.onChange && typeof _this.props.onChange==='function') {
          // _this.props.onChange(this.codeEditor.getTextArea().value);
          _this.props.onChange(this.getMarkdown());
          if(_this.imageInstance) {
            _this.imageInstance.update();
          }
        }
      },
      onload: function () {
        this.settings.appId = appId;
        this.unwatch();
        // console.log(this);
        this.cm.clearHistory();
        this.cm.on("blur", function(){
          // ecodeStore.setContentObjLs();
        });
        _this.instance = this;
        if(_this.props.onChange && typeof _this.props.onChange==='function') {
          const val = _this.props.ecodeStore.readme||'';
          if(val==='') {
            this.clear();
          } else {
            _this.props.onChange(val);
            _this.instance.setMarkdown(val);
          }
            ecodeStore.setLoading(false);
          this.watch();
          _this.createViewer();
          if(_this.imageInstance) {
            // _this.imageInstance.reset();
            _this.imageInstance.update();
          }
        }
        var keyMap = {
          "Ctrl-S": function(cm) {
            // console.log('Ctrl-S');
            if(_this.props.onSave && typeof _this.props.onSave==='function') {
              _this.props.onSave();
            }
          },
          "Cmd-S": function(cm) {
            // console.log('Cmd-S');
            if(_this.props.onSave && typeof _this.props.onSave==='function') {
              _this.props.onSave();
            }
          },
          // "Cmd-V": (cm) => {
          //   console.log('Cmd-V:',cm);
          //   // this.insertValue("<a href=\"http://www.baidu.com/\" target=\"_blank\">Hello, world!</a>");
          // },
          // "Ctrl-V": (cm) => {
          //   console.log('Ctrl-V:',cm);
          // }
        };
        this.addKeyMap(keyMap);
        window.editormd.loadPlugin("https://e-cloudstore.com/doc/editormd/plugins/image-handle-paste/image-handle-paste", () => {
          const { ecodeStore: { demoInfo } } = _this.props;
          this.imagePaste({appId, folderId: toJS(demoInfo).folderId});
        });
        // console.log(this);
        // $("#post_content").on('paste', function (e) {
        //   console.log(e);
        // });
        // console.log('componentDidMount:',_this.instance);
      }
    });
  }
  getSnapshotBeforeUpdate(preProps) {
    if(this.instance) {
      const { ecodeStore: { readme, setMobxState, isEdit }, appId } = this.props;
      this.instance.settings.appId = appId;
      if(readme!==this.instance.getMarkdown()) {

        if(!readme||readme==='') {
          // console.log(this.instance);
          this.instance.clear();
          // if(this.props.onChange && typeof this.props.onChange==='function')
          //   this.props.onChange(code||'');
        }
        else {
          this.instance.setMarkdown(readme);
        }
        if(this.imageInstance) {
          // this.imageInstance.reset();
          this.imageInstance.update();
        }
        // console.log(preProps.activeKey!==this.props.activeKey);
        if(preProps.activeKey!==this.props.activeKey) {
          // if(this.imageInstance) this.imageInstance.destroy();
          if(this.instance) {
            this.instance.cm.clearHistory();
            // this.instance.clear();
          }
          // const viewer = new Viewer(document.getElementById('md-editor'), {
          //   inline: false,
          //   viewed() {
          //     // console.log('viewer:',viewer);
          //     // viewer.zoomTo(1);
          //   },
          //   url(img) {
          //     if(img.src.indexOf('cloudstore/release')>=0) {
          //       return img.src.replace('.png','-big.png');
          //     }
          //     else {
          //       return img.src;
          //     }
          //   }
          // });
          // this.imageInstance = viewer;
          this.init();
        }
        // this.instance.setValue(code);
        // this.instance.unwatch();
        // this.instance.watch();
      }
    }
  }

  componentWillUnmount() {
    // if(this.instance) {
      // if(this.instance) this.instance.clear();
      // let val = this.instance.getMarkdown();
      // if(val&&val!=='') {
      //   //this.instance.clear();
      //   // console.log(this.instance);
      //   // this.instance.setMarkdown('');
      // }
    // }
    if(this.imageInstance) {
      this.imageInstance.destroy();
    }
  }
  render() {
    return (
      <div id="md-editor">
        <textarea style={{display:'none'}}></textarea>
      </div>
    )
  }
}

export default MdEditor;



// WEBPACK FOOTER //
// ./src/components/ecodeLocal/EditorMd.js